module.exports = __webpack_public_path__ + "media/images/incarcerated_girls/SanGabrielsTrail_BW-p-1600-8fe34e78c4d27f9ebf488e3581bc109d.jpg";